module.exports = __webpack_public_path__ + "media/images/application/template/spacer-86d72a5faad6b61cac362d93b0458282.png";